import Icon from 'components/Kizen/Icon';
import IconButtonMenu from 'components/Kizen/IconButtonMenu';
import { useTruncationTooltip } from 'components/Kizen/Tooltip';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { StyledEditableText } from '../styles';
import { EditableItemContainer, EditableItemThreeDotContainer } from './styles';

const LogActivityItem = ({
  item,
  editable,
  index,
  childIndex,
  editValue,
  onOpenMenu,
  onCloseMenu,
  editOptions,
  removeItem,
}) => {
  const { t } = useTranslation();

  const onChangeDisplayName = useCallback(
    (value) => {
      editValue(index, childIndex, 'displayName', value);
    },
    [editValue, index, childIndex]
  );

  const options = useMemo(() => {
    return [
      {
        value: 'remove',
        label: t('Remove from Toolbar'),
      },
      {
        value: 'edit',
        label: t('Edit Options'),
      },
    ];
  }, [t]);

  const handleChooseValue = useCallback(
    ({ value }) => {
      switch (value) {
        case 'remove':
          return removeItem(index, childIndex);
        case 'edit':
          return editOptions(index, childIndex, item);
        default:
          break;
      }
    },
    [removeItem, editOptions, childIndex, index, item]
  );

  const [tooltipProps, tooltip] = useTruncationTooltip({
    label: item.displayName,
  });

  return (
    <EditableItemContainer>
      {editable ? (
        <>
          <StyledEditableText
            value={item.displayName}
            placeholder={t('Display Name')}
            onChange={onChangeDisplayName}
            {...tooltipProps}
          />
          {tooltip}
        </>
      ) : null}
      <EditableItemThreeDotContainer child={childIndex > -1}>
        <IconButtonMenu
          title={t('Edit Log Activity')}
          position="right"
          sizing="dense"
          options={options}
          onOpen={onOpenMenu}
          onClose={onCloseMenu}
          onChange={handleChooseValue}
          restrictCloseHandler
        >
          <Icon icon="three-dot" />
        </IconButtonMenu>
      </EditableItemThreeDotContainer>
    </EditableItemContainer>
  );
};

export default LogActivityItem;
